import PropTypes from 'prop-types';
import { Link } from 'gatsby';

const isActive = ({ isCurrent }) => (isCurrent ? { className: 'active' } : null);

const NavLink = ({
  route,
  children,
  ...rest
}) => (
  <Link
    to={route}
    getProps={isActive}
    {...rest}
  >
    {children}
  </Link>
);

NavLink.propTypes = {
  route: PropTypes.string.isRequired,
  children: PropTypes.any.isRequired,
};

export default NavLink;
